import { render } from "./ZahlungsMethodenWahl.vue?vue&type=template&id=9b90baec"
import script from "./ZahlungsMethodenWahl.vue?vue&type=script&lang=js"
export * from "./ZahlungsMethodenWahl.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__